const SHOP_URL = (Grabcad.locale ? `/${Grabcad.locale}` : '') + '/shop';

export default {
    data () {
        return {
            signUpModalActive: false
        };
    },
    methods: {
        triggerSignUpModal () {
            location.hash = 'signUp'
            this.signUpModalActive = true;
        },
        cancelSignUpModal () {
            location.hash = '';
            this.signUpModalActive = false;
        },
        triggerLoginModal () {
            window.$$loginEventHub.$emit('signInModalTrigger', {
                loginCallback: this.loginCallback
            });
        },
        loginCallback ({isShopUser}) {
            if (isShopUser) {
                window.location = SHOP_URL
            } else {
                location.hash = 'signUp'
                location.reload();
            }
        }
    },
    mounted () {
        if (location.hash === '#signUp') {
            this.triggerSignUpModal();
        }
    }
}